import { memo } from "react";

export const ExtendedWarrantyDetails = memo(function ExtendedWarrantyDetails() {
  return null;
});
